import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Hero from '../components/Hero'
import About from '../components/About'
import ServicesScroll from '../components/ServicesScroll'
import FeaturedWork from '../components/FeaturedWork'
// import Testimonials from '../components/Testimonials'
import FAQ from '../components/FAQ'
import Blog from '../components/Blog'
import Contact from '../components/Contact'
import TechMarquee from '../components/TechMarquee'
import PageMeta from '../components/PageMeta'
import StructuredData from '../components/StructuredData'

const HomePage = () => {
  return (
    <div>
      <PageMeta 
        title="Professional Web Design Centurion | RDS Studio — WordPress, SEO & Google Ads"
        description="Professional web design agency in Centurion. Custom WordPress websites from R8,500, technical SEO & Google Ads. Serving Centurion, Pretoria & Gauteng since 2014. Free quote today."
        canonical="https://rdsstudio.co.za"
      />
      <StructuredData />
      <Header />
      <main id="main-content" className="main-content" role="main">
        <Hero />

        {/* Quick Start: Four-Pillar Navigation */}
        <section className="section">
          <div className="section-inner">
            <h2 className="title title-h2">How We Can<br/>Help You</h2>
            <p className="description">From custom web development to private cloud infrastructure, digital marketing, and SEO optimization -- our agency delivers professional services with direct communication, expert execution, and transparent pricing.</p>
            <div className="services-grid">
              <div className="service-card">
                <h3>Who We Are</h3>
                <p>Leading digital agency in Centurion with 10+ years experience delivering web development, cloud infrastructure, and marketing solutions to South African businesses.</p>
                <a className="btn btn-secondary" href="/about">About Us</a>
              </div>
              <div className="service-card">
                <h3>What We Do</h3>
                <p>Full-service digital agency specializing in web development, private cloud setup, digital marketing, and comprehensive SEO strategies that drive growth.</p>
                <a className="btn btn-secondary" href="/services">All Services</a>
              </div>
              <div className="service-card">
                <h3>Our Work</h3>
                <p>Explore our portfolio of successful websites and digital projects. Each solution is strategically crafted to achieve specific business objectives and deliver ROI.</p>
                <a className="btn btn-secondary" href="/portfolio">View Work</a>
              </div>
              <div className="service-card">
                <h3>Resources</h3>
                <p>Helpful articles on web development, cloud infrastructure, and digital marketing best practices.</p>
                <a className="btn btn-secondary" href="/blog">Read Articles</a>
              </div>
            </div>
          </div>
        </section>

        {/* Keep in-page previews for SEO and quick scanning */}
        <About />
        
        {/* What We Offer Section Header */}
        <section className="section what-i-offer-header">
          <div className="section-inner">
            <h2 className="title title-h2">What We<br/>Offer</h2>
          </div>
        </section>
        
        <ServicesScroll />
        <FeaturedWork />
        {/* <Testimonials /> */}
        <FAQ />
        <Blog />
        <Contact />
      </main>

      <TechMarquee />
      <Footer />
    </div>
  )
}

export default HomePage
